// src/frontend/Adviser/Hooks/useAdviserPostcodesWithStatus.js
import { useEffect, useState } from "react";
import { db } from "../../../backend/firebaseConfig";
import {
  collection,
  getDocs,
  doc,
  getDoc,
} from "firebase/firestore";

export function useAllAdvisersData() {
  const [rows, setRows] = useState([]); // [{ id, postcode, status }]
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    async function fetchAll() {
      try {
        // 1) All adviser docs (status)
        const advisersSnap = await getDocs(
          collection(db, "Authorized Members", "Advisers", "Data")
        );
        const adviserById = new Map();
        advisersSnap.docs.forEach((d) => {
          const adviser = d.data() || {};
          if (adviser.isAppointed === false) return;
          adviserById.set(d.id, {
            email: adviser.email || d.id,
            status: Array.isArray(adviser.status) ? adviser.status : [],
            businessAddress: adviser.businessAddress || "",
            businessAreas: adviser.businessAreas || [],
            ARBusinessAreas: adviser.ARBusinessAreas || [],
          });
        });

        // 2) All Personal Details docs
        // const pdSnap = await getDocs(collectionGroup(db, "Personal Details"));
        const out = [];
        for (const [adviserId, adviser] of adviserById.entries()) {
          const pdRef = doc(
            db,
            "Authorized Members",
            "Advisers",
            "Data",
            adviserId,
            "Personal Details",
            "Data"
          );
          const applicationRef = doc(
            db,
            "Authorized Members",
            "Advisers",
            "Data",
            adviserId,
            "Application Details",
            "Data"
          );
          const [pd, application] = await Promise.all([
            getDoc(pdRef),
            getDoc(applicationRef),
          ]);
          const data = pd.data() || {};
          const applicationData = application.data() || {};
          const residentialPostcode = (
            data.currentPostcode ||
            data.currentPostCode ||
            ""
          ).trim();
          const businessAddress = String(
            data.businessAddress?.fullAddress ||
              data.businessAddress ||
              adviser.businessAddress ||
              ""
          ).trim();
          if (residentialPostcode || businessAddress) {
            out.push({
              id: adviserId,
              email: adviser.email,
              postcode: residentialPostcode,
              residentialPostcode,
              businessAddress,
              status: adviser.status,
              permissions: [
                ...(Array.isArray(applicationData.businessAreas)
                  ? applicationData.businessAreas
                  : Array.isArray(adviser.businessAreas)
                    ? adviser.businessAreas
                    : []),
                ...(Array.isArray(applicationData.ARBusinessAreas)
                  ? applicationData.ARBusinessAreas
                  : Array.isArray(adviser.ARBusinessAreas)
                    ? adviser.ARBusinessAreas
                    : []),
              ],
            });
          }
        }
        setRows(out);

        if (!cancelled) setRows(out);
      } catch (e) {
        // console.error("Fetching postcodes+status failed:", e);
        if (!cancelled) setRows([]);
      } finally {
        if (!cancelled) setLoading(false);
      }
    }

    fetchAll();
    return () => {
      cancelled = true;
    };
  }, []);

  return { postcodes: rows, loading };
}
